export default "__VITE_ASSET__BWN$l3x4__"